import { ReactNode } from 'react';
import { TopNavigation } from './TopNavigation';
import { DesktopContainer } from './DesktopContainer';

interface DesktopLayoutProps {
  children: ReactNode;
  hasContainer?: boolean;
  className?: string;
}

export function DesktopLayout({ 
  children, 
  hasContainer = true,
  className = '' 
}: DesktopLayoutProps) {
  return (
    <div className="min-h-screen bg-[#F5F5F5]">
      <TopNavigation />
      
      {/* Main content with top padding for fixed nav */}
      <main className={`pt-[72px] ${className}`}>
        {hasContainer ? (
          <DesktopContainer>
            {children}
          </DesktopContainer>
        ) : (
          children
        )}
      </main>
    </div>
  );
}